import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "total"];

  declare readonly inputTargets: HTMLInputElement[];
  declare readonly totalTarget: HTMLInputElement;

  connect(): void {
    this.inputTargets.forEach((input) => {
      const hidden = input.previousElementSibling as HTMLInputElement;
      const raw = hidden ? parseInt(hidden.value, 10) : 0;
      input.value = raw > 0 ? this.formatNumber(raw) : "";
    });
    this.calculateTotal();
  }

  calculateTotal(): void {
    const total = this.inputTargets.reduce((sum, input) => {
      const hidden = input.previousElementSibling as HTMLInputElement;
      const v = parseInt(hidden.value, 10) || 0;
      return sum + v;
    }, 0);
    this.totalTarget.value = this.formatNumber(total);
  }

  handleFocus(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = this.parseNumber(input.value);
    input.value = value > 0 ? value.toString() : "";
  }

  handleBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = this.parseNumber(input.value);

    input.value = this.formatNumber(value);
    this.updateHiddenFromInput(input);
    this.calculateTotal();
  }

  syncHidden(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.updateHiddenFromInput(input);
    this.calculateTotal();
  }

  private updateHiddenFromInput(input: HTMLInputElement): void {
    const hidden = input.previousElementSibling as HTMLInputElement;
    if (!hidden) return;
    hidden.value = this.parseNumber(input.value).toString();
  }

  private formatNumber(value: number): string {
    return value.toLocaleString();
  }

  private parseNumber(value: string): number {
    if (!value) return 0;
    return parseInt(value.replace(/,/g, "")) || 0;
  }
}
